<template>
    <div class="modal fade" :id="id" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <form v-on:submit="submit">
                    <div class="modal-header d-flex justify-content-between align-items-start">
                        <h5 class="modal-title fw-bold text-black">
                            <template v-if="event_update">
                                {{ $t('cta.edit_event') }}
                            </template>
                            <template v-else>
                                {{ $t('cta.add_event') }}
                            </template>
                            <span class="d-block fw-normal" v-if="patient_summary !== undefined">{{ patient_summary.firstname }} {{ patient_summary.lastname }}</span>
                        </h5>
                        <button class="bg-transparent border-0 close-btn lh-1 p-10 text-muted" type="button"
                            data-bs-dismiss="modal" @click="restoreData()">
                            <i class="ph-bold ph-x"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        
                        <div class="row" v-if="time">
                            <!-- START AT -->
                            <div class="col-md-6">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        {{ $t('form.start_at.label') }}*
                                    </label>
                                    <div class="row">
                                        <div class="col">
                                            <input v-model="event.started_at" type="date" required :disabled="!editable"
                                                class="form-control shadow-none text-black"
                                                :class="[{ 'is-invalid': submitted && errors?.started_at }]" />
                                        </div>
                                        <div class="col-4 d-flex">
                                            <input v-model="event.start_time" pattern="[0-9]{2}:[0-9]{2}" type="time"
                                                required class="form-control shadow-none text-black" :disabled="event.all_day || !editable"
                                                :class="[{ 'is-invalid': submitted && errors?.start_time }]" />
                                        </div>
                                        <div class="col-12">
                                            <!-- ERRORS -->
                                            <div class="form-messages mt-2 px-1" v-if="errors?.started_at ?? false">
                                                <p v-for="error in errors.started_at" :key="error"
                                                    class="small text-danger lh-1 m-0 mt-1">{{ error }}</p>
                                            </div>
                                            <!-- ERRORS -->
                                            <div class="form-messages mt-2 px-1" v-if="errors?.start_time ?? false">
                                                <p v-for="error in errors.started_at" :key="error"
                                                    class="small text-danger lh-1 m-0 mt-1">{{ error }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- END AT -->
                            <div class="col-md-6">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        {{ $t('form.end_at.label') }}*
                                    </label>
                                    <div class="row">
                                        <div class="col">
                                            <input v-model="event.ended_at" type="date" required :disabled="!editable"
                                                class="form-control shadow-none text-black" :min="event.started_at"
                                                :class="[{ 'is-invalid': submitted && errors?.ended_at }]" />

                                        </div>
                                        <div class="col-4 d-flex" >
                                            <input v-model="event.end_time" pattern="[0-9]{2}:[0-9]{2}" type="time" :disabled="event.all_day || !editable"
                                                :class="[{ 'is-invalid': submitted && errors?.end_time }]" required
                                                class="form-control shadow-none text-black" />
                                        </div>
                                        <div class="col-12">
                                            <!-- ERRORS -->
                                            <div class="form-messages mt-2 px-1" v-if="errors?.ended_at ?? false">
                                                <p v-for="error in errors.ended_at" :key="error"
                                                    class="small text-danger lh-1 m-0 mt-1">{{ error }}</p>
                                            </div>
                                            <!-- ERRORS -->
                                            <div class="form-messages mt-2 px-1" v-if="errors?.end_time ?? false">
                                                <p v-for="error in errors.end_time" :key="error"
                                                    class="small text-danger lh-1 m-0 mt-1">{{ error }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- ALL DAY -->
                            <!-- <div class="col-12">
                                <div class="form-check form-switch form-group mb-15 mb-sm-20 mb-md-25">
                                    <input class="form-check-input shadow-none me-8" type="checkbox" role="switch"
                                        v-model="event.all_day" @change="resetTimes">
                                    <label class="form-check-label fw-medium position-relative">
                                        {{ $t('feature.$events.all_day') }}
                                    </label>
                                </div>
                            </div> -->
                            <!-- TYPE -->
                            <div class="col-md-6">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        {{ $t('form.type.label') }}
                                    </label>
                                    <div>
                                        <select class="form-select shadow-none text-black fs-md-15" required :disabled="!editable"
                                            :class="[{ 'is-invalid': submitted && errors?.event_type_id }]"
                                            v-model.number="event.event_type_id">
                                            <option v-for="types in event_types" :key="types.id" :value="types.id"
                                                :selected="event.event_type_id === types.id">
                                                {{ types.name }}</option>
                                        </select>
                                        <!-- ERRORS -->
                                        <div class="form-messages mt-2 px-1" v-if="errors?.event_type_id ?? false">
                                            <p v-for="error in errors.event_type_id" :key="error"
                                                class="small text-danger lh-1 m-0 mt-1">{{ error }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12"></div>
                            <!-- LOCATION -->
                            <div class="col-12">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        {{ $t('form.location.label') }}*
                                    </label>
                                    <input type="text" v-model="event.location" required :disabled="!editable"
                                        :class="[{ 'is-invalid': submitted && errors?.location }]"
                                        class="form-control shadow-none text-black"
                                        :placeholder="$t('form.location.placeholder')" />
                                    <!-- ERRORS -->
                                    <div class="form-messages mt-2 px-1" v-if="errors?.location ?? false">
                                        <p v-for="error in errors.location" :key="error"
                                            class="small text-danger lh-1 m-0 mt-1">{{ error }}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- DESCRIPTION -->
                            <div class="col-12">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        {{ $t('form.description.label') }}
                                    </label>
                                    <textarea v-model="event.description" class="form-control shadow-none text-black" :disabled="!editable"
                                        :class="[{ 'is-invalid': submitted && errors?.description }]" cols="8"
                                        :placeholder="$t('form.description.placeholder')"></textarea>
                                    <!-- ERRORS -->
                                    <div class="form-messages mt-2 px-1" v-if="errors?.description ?? false">
                                        <p v-for="error in errors.description" :key="error"
                                            class="small text-danger lh-1 m-0 mt-1">{{ error }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="text-center w-100" v-if="loading">
                            <SpinnerLoading />
                        </div>
                        <div class="d-flex justify-content-between w-100" v-else>
                            <!-- DELETE -->
                            <button v-if="event_update" type="button"
                                class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium" @click="deleteEvent">
                                <i class="ph ph-trash lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative">{{ $t('cta.delete_event') }}</span>
                            </button>
                            <span v-else></span>
                            <!-- SAVE -->
                            <button type="submit" v-if="event_update == undefined || editable"
                                class="default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16">
                                {{ $t('cta.save_event') }}
                            </button>
                            <span v-else></span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    
</template>

<script lang="ts">
import API from '@/services/api/api.service';
import { PropType } from 'vue';
import { defineComponent } from 'vue';

import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { EventTimeInfo, eventFromTimeInfo, EventType, Event, EventUserSummary } from "@/utils/models/event.model";
import { removeNullProperties } from '@/utils/methods/remove_null_properties';
import DateFormatUtils from '@/utils/methods/date_formats';
import dayjs from 'dayjs';
import { parse_date_time } from '@/utils/methods/event_dates';

export default defineComponent({
    props: {
        id: {
            type: String,
            required: true
        },
        event_update: {
            type: Object as PropType<Event>,
            required: false
        },
        patient_summary: {
            type: Object as PropType<EventUserSummary>,
            required: false
        },
        time_info: {
            type: Object as PropType<EventTimeInfo | undefined>,
            required: false,
        },
    },
    data: function () {
        return {
            submitted: false,
            loading: false,
            errors: undefined as any,
            event_types: undefined as EventType[] | undefined,
            time: this.time_info ?? {} as EventTimeInfo,
            event: this.event_update ?? eventFromTimeInfo(this.time_info ?? {} as EventTimeInfo) as Event,
        }
    },
    watch: {
        event_update: function (newVal, oldVal) {
            this.event = newVal ?? eventFromTimeInfo(this.time_info ?? {} as EventTimeInfo);
            /* if (this.event_types?.length === 1) {
                this.event.event_type_id = this.event_types[0].id as number;
            } */
            this.event.start_time = DateFormatUtils.HHmm(DateFormatUtils.dateFromDayTime(this.event.started_at, this.event.start_time));
            this.event.end_time = DateFormatUtils.HHmm(DateFormatUtils.dateFromDayTime(this.event.ended_at, this.event.end_time));
        },
        time_info: function (newVal, oldVal) {
            console.debug('update', newVal);
            this.time = newVal;
            this.event = eventFromTimeInfo(newVal);
            if (this.event_types?.length === 1) {
                this.event.event_type_id = this.event_types[0].id as number;
            }
        },
        '$i18n.locale': function (oldVal, newVal) {
            this.getEventTypes();
        }
    },
    mounted() {
        this.getEventTypes();
    },

    computed: {
        editable():boolean {
            if (this.event_update === undefined) return true;
            let parsed_date_start = parse_date_time(this.event_update?.started_at!, this.event_update?.start_time!);
            // console.log(dayjs(parsed_date_start).isAfter(dayjs()))
            return dayjs(parsed_date_start).isAfter(dayjs());
        }
    },
    methods: {
        getEventTypes() {
            API.getEventTypes().then((response) => {
                if (response.data.success === true) {
                    this.event_types = response.data.data;
                } else {
                    this.event_types = [];
                }
            }).catch((error) => {
                this.event_types = [];
            })
        },
        restoreData() {
            this.reset();
            this.submitted = false;
            this.loading = false;
            this.errors = undefined as any;
        },
        reset() {
            // this.event = eventFromTimeInfo({} as EventTimeInfo);
        },
        submit(event) {
            this.errors = undefined;
            this.loading = true;
            event.preventDefault();
            console.debug('SUBMIT');
            if (this.event_update === undefined) {
                /* CREATE */
                API.createEvent({ patient_id: this.patient_summary!.id!, event: this.event }).then((response) => {
                    console.debug(response);
                    if (response.data.success === true && response.data.data != undefined) {
                        this.restoreData();
                        this.$emit('save', response.data.data);
                    }
                }).catch((error) => {
                    this.errors = error.response?.data?.errors;
                }).finally(() => {
                    this.loading = false;
                });
            } else {
                /* UPDATE */
                removeNullProperties<Event>(this.event);
                API.updateEvent({ event: this.event }).then((response) => {
                    if (response.data.success === true) {
                        this.restoreData();
                        this.$emit('update', this.event);
                    }
                }).catch((error) => {
                    this.errors = error.response?.data?.errors;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        resetTimes() {
            this.event.start_time = '00:00';
            this.event.end_time = '00:00';
        },
        deleteEvent() {
            this.$emit('delete');
        }
    },
    components: {
        SpinnerLoading,
    },
    name: "EventsModal",
});
</script>